import { createHTTPClient } from "@airhelp/http-client";
import { caller, valid } from "@airhelp/http-client/addons";
import { b, a, d, c, g, e, f, j, h, i, m, l, k, n } from "./logout-yCeX-sS8.js";
function createBaseAuthHTTPClient({
  caller: caller$1,
  baseURL,
  options
}) {
  return createHTTPClient({
    baseURL,
    options: {
      credentials: "include",
      ...options
    }
  }).addon(caller).addon(
    valid({
      preprocess: false
    })
  ).caller(caller$1);
}
function refreshAccessToken({ client }) {
  return client.url("/api/v1/auth/refresh").post().text();
}
export {
  b as accessMagicLink,
  a as accessMagicLinkRequestSchema,
  d as beginPasswordReset,
  c as beginPasswordResetRequestSchema,
  createBaseAuthHTTPClient,
  g as createNewPassword,
  e as createNewPasswordRequestSchema,
  f as createNewPasswordResponseSchema,
  j as createUser,
  h as createUserRequestSchema,
  i as createUserResponseSchema,
  m as login,
  l as loginRequestSchema,
  k as loginResponseSchema,
  n as logout,
  refreshAccessToken
};
//# sourceMappingURL=index.js.map
